// Configuration file for API endpoints

// Local development configuration
// export const API_URL = 'http://localhost:8080/api/chat';
// export const WEBSOCKET_URL = 'ws://localhost:8080/api/v1/chat-stream-relay';

// // Development configuration
export const API_URL = 'https://chat-dev.otter.com.co/api/chat';
export const WEBSOCKET_URL = 'wss://chat-dev.otter.com.co/api/v1/chat-stream-relay';

// Production configuration
// export const API_URL = 'https://chat-prod.otter.com.co/api/chat';
// export const WEBSOCKET_URL = 'wss://chat-prod.otter.com.co/api/v1/chat-stream-relay';

// India Production configuration
// export const API_URL = 'https://chat-ind-prod.otter.com.co/api/chat';
// export const WEBSOCKET_URL = 'wss://chat-ind-prod.otter.com.co/api/v1/chat-stream-relay';

// Environment configuration (based on the current API_URL)
export const ENVIRONMENT = API_URL.toLowerCase().includes('localhost') ? 'local'
     : API_URL.toLowerCase().includes('chat-dev') ? 'development'
          : 'production';

export const ALLOW_DEVTOOLS = ENVIRONMENT === 'local' || ENVIRONMENT === 'development';

// API Keys and URLs
export const OPENAI_API_KEY = '';
export const ANTHROPIC_API_KEY = '';
export const DEEPGRAM_URL = 'wss://api.deepgram.com/v1/listen?model=nova-2&punctuate=true&interim_results=true&no_audio_timeout=200';
export const AES_SECRET_KEY= 'jzp7LJ1OH2pbjH0un6A7bE2OL5oLXI1+H0qbLF2OP3o='

export const emails = {
     "Jagadish": 'p_jagadish@sbcgroup-india.com',
     "Sarath": 'k_sarath@sbcgroup-india.com',
     "veeraju": 'veeraju.medha@sbcgroup-india.com'
}



